import { _ as __awaiter, a as __generator } from './tslib.es6-e24bb3a5.js';
import ColorThief from 'colorthief';
import exif from 'exif-js';

var ImageUtils = function () {
  function ImageUtils() {
    var _this = this;

    this._canvas = document.createElement('canvas');
    this._queue = Promise.resolve();

    this._clearCanvas = function () {
      var ctx = _this._canvas.getContext('2d');

      ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, _this._canvas.width, _this._canvas.height);
    };

    this._reload = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var objectURL, _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4, this._toBlobURL()];

            case 1:
              objectURL = _b.sent();
              _a = this;
              return [4, ImageUtils.loadImage(objectURL)];

            case 2:
              _a._image = _b.sent();
              return [2];
          }
        });
      });
    };

    this.load = function (source, width, height) {
      _this._queue = _this._queue.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, ctx;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _a = this;
                return [4, ImageUtils.loadImage(source, width, height)];

              case 1:
                _a._image = _b.sent();

                this._clearCanvas();

                ctx = this._canvas.getContext('2d');
                this._canvas.width = this._image.width;
                this._canvas.height = this._image.height;
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0);
                return [2];
            }
          });
        });
      });
      return _this;
    };

    this.getCanvas = function () {
      return _this._queue.then(function () {
        return _this._canvas;
      });
    };

    this.toImage = function () {
      return _this._queue.then(function () {
        return _this._image;
      });
    };

    this.toDataURL = function (format, quality) {
      return _this._queue.then(function () {
        return _this._canvas.toDataURL(format, quality);
      });
    };

    this.toBlob = function (format, quality) {
      return _this._queue.then(function () {
        return _this._toBlob(format, quality);
      });
    };

    this._toBlob = function (format, quality) {
      return new Promise(function (resolve, reject) {
        _this._canvas.toBlob(function (blob) {
          if (blob) resolve(blob);
          reject();
        }, format, quality);
      });
    };

    this._toBlobURL = function (format, quality) {
      return new Promise(function (resolve, reject) {
        _this._canvas.toBlob(function (blob) {
          if (blob) resolve((window.URL || window.webkitURL).createObjectURL(blob));
          reject();
        }, format, quality);
      });
    };

    this.toBlobURL = function (format, quality) {
      return _this._queue.then(function () {
        return _this._toBlobURL(format, quality);
      });
    };

    this.dispose = function () {
      return _this._queue.then(function () {
        _this._canvas.width = _this._canvas.height = 0;
        _this._image = undefined;
      });
    };

    this.cropper = function () {
      var argument = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        argument[_i] = arguments[_i];
      }

      _this._queue = _this._queue.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var left, top_1, width, height, ctx;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                this._clearCanvas();

                if (!this._image) return [3, 2];
                left = argument[0], top_1 = argument[1], width = argument[2], height = argument[3];

                if (argument.length === 2) {
                  width = argument[0];
                  height = argument[1];
                  left = (this._image.width - width) / 2;
                  top_1 = (this._image.height - height) / 2;
                }

                this._canvas.width = width;
                this._canvas.height = height;
                ctx = this._canvas.getContext('2d');
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, left, top_1, width, height, 0, 0, this._canvas.width, this._canvas.height);
                return [4, this._reload()];

              case 1:
                _a.sent();

                _a.label = 2;

              case 2:
                return [2];
            }
          });
        });
      });
      return _this;
    };

    this.trim = function () {
      _this._queue = _this._queue.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var ctx, left, top_2, right, bottom, imageData_1, ltPixels_1, y, _loop_1, this_1, x;

          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                this._clearCanvas();

                if (!this._image) return [3, 2];
                ctx = this._canvas.getContext('2d');
                this._canvas.width = this._image.width;
                this._canvas.height = this._image.height;
                left = this._image.width, top_2 = this._image.height, right = 0, bottom = 0;
                ctx.drawImage(this._image, 0, 0);
                imageData_1 = ctx.getImageData(0, 0, this._canvas.width, this._canvas.height);
                ltPixels_1 = imageData_1.data.slice(0, 4);

                for (y = 0; y < this._canvas.height; y++) {
                  _loop_1 = function (x) {
                    var i = (y * this_1._canvas.width + x) * 4;

                    if (Array.from({
                      length: 4
                    }).filter(function (_, index) {
                      return ltPixels_1[index] === imageData_1.data[i + index];
                    }).length < 4) {
                      left = Math.min(x, left);
                      top_2 = Math.min(y, top_2);
                      right = Math.max(x, right);
                      bottom = Math.max(y, bottom);
                    }
                  };

                  this_1 = this;

                  for (x = 0; x < this._canvas.width; x++) {
                    _loop_1(x);
                  }
                }

                this._canvas.width = right - left;
                this._canvas.height = bottom - top_2;

                this._clearCanvas();

                ctx.drawImage(this._image, left, top_2, this._canvas.width, this._canvas.height, 0, 0, this._canvas.width, this._canvas.height);
                return [4, this._reload()];

              case 1:
                _a.sent();

                _a.label = 2;

              case 2:
                return [2];
            }
          });
        });
      });
      return _this;
    };

    this.getOrientation = function () {
      return new Promise(function (resolve) {
        if (_this._image) {
          exif.getData(_this._image, function () {
            var orientation = exif.getTag(_this._image, 'Orientation');
            resolve(orientation);
          });
        }

        resolve(0);
      });
    };

    this.orientation = function (orientation) {
      _this._queue = _this._queue.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, ctx;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                this._clearCanvas();

                if (!this._image) return [3, 5];
                if (!(orientation !== null && orientation !== void 0)) return [3, 1];
                _a = orientation;
                return [3, 3];

              case 1:
                return [4, this.getOrientation()];

              case 2:
                _a = _b.sent();
                _b.label = 3;

              case 3:
                orientation = _a;
                ctx = this._canvas.getContext('2d');

                switch (orientation) {
                  case 3:
                    this._canvas.width = this._image.width;
                    this._canvas.height = this._image.height;
                    ctx === null || ctx === void 0 ? void 0 : ctx.translate(this._canvas.width / 2, this._canvas.height / 2);
                    ctx === null || ctx === void 0 ? void 0 : ctx.rotate(180 * Math.PI / 180);
                    ctx === null || ctx === void 0 ? void 0 : ctx.translate(-this._canvas.height / 2, -this._canvas.width / 2);
                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0, this._image.width, this._image.height, 0, 0, this._canvas.width, this._canvas.height);
                    break;

                  case 6:
                    this._canvas.width = this._image.height;
                    this._canvas.height = this._image.width;
                    ctx === null || ctx === void 0 ? void 0 : ctx.translate(this._canvas.width / 2, this._canvas.height / 2);
                    ctx === null || ctx === void 0 ? void 0 : ctx.rotate(90 * Math.PI / 180);
                    ctx === null || ctx === void 0 ? void 0 : ctx.translate(-this._canvas.height / 2, -this._canvas.width / 2);
                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0, this._image.width, this._image.height, 0, 0, this._canvas.height, this._canvas.width);
                    break;

                  case 8:
                    this._canvas.width = this._image.height;
                    this._canvas.height = this._image.width;
                    ctx === null || ctx === void 0 ? void 0 : ctx.translate(this._canvas.width / 2, this._canvas.height / 2);
                    ctx === null || ctx === void 0 ? void 0 : ctx.rotate(270 * Math.PI / 180);
                    ctx === null || ctx === void 0 ? void 0 : ctx.translate(-this._canvas.height / 2, -this._canvas.width / 2);
                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0, this._image.width, this._image.height, 0, 0, this._canvas.height, this._canvas.width);
                    break;

                  default:
                    this._canvas.width = this._image.width;
                    this._canvas.height = this._image.height;
                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0, this._image.width, this._image.height, 0, 0, this._canvas.width, this._canvas.height);
                    break;
                }

                return [4, this._reload()];

              case 4:
                _b.sent();

                _b.label = 5;

              case 5:
                return [2];
            }
          });
        });
      });
      return _this;
    };

    this.replace = function (replaceFn) {
      _this._queue = _this._queue.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var ctx, imageData_2, y, _loop_2, this_2, x;

          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!this._image) return [3, 2];

                this._clearCanvas();

                this._canvas.width = this._image.width;
                this._canvas.height = this._image.height;
                ctx = this._canvas.getContext('2d');
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0);
                imageData_2 = ctx.getImageData(0, 0, this._canvas.width, this._canvas.height);

                for (y = 0; y < this._canvas.height; y++) {
                  _loop_2 = function (x) {
                    var i = (y * this_2._canvas.width + x) * 4;
                    replaceFn(Array.from({
                      length: 4
                    }).map(function (_, index) {
                      return imageData_2.data[i + index];
                    })).forEach(function (item, index) {
                      imageData_2.data[i + index] = item;
                    });
                  };

                  this_2 = this;

                  for (x = 0; x < this._canvas.width; x++) {
                    _loop_2(x);
                  }
                }

                ctx === null || ctx === void 0 ? void 0 : ctx.putImageData(imageData_2, 0, 0);
                return [4, this._reload()];

              case 1:
                _a.sent();

                _a.label = 2;

              case 2:
                return [2];
            }
          });
        });
      });
      return _this;
    };

    this.compose = function (size) {
      _this._queue = _this._queue.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var ctx;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                this._clearCanvas();

                if (!this._image) return [3, 2];

                if (typeof size === 'number') {
                  if (this._image.width < this._image.height) {
                    this._canvas.height = Math.min(size, this._image.height);
                    this._canvas.width = this._canvas.height * this._image.width / this._image.height;
                  } else {
                    this._canvas.width = Math.min(size, this._image.width);
                    this._canvas.height = this._canvas.width * this._image.height / this._image.width;
                  }
                } else {
                  if (size.width && size.height) {
                    if (this._image.width / this._image.height < size.width / size.height) {
                      this._canvas.height = Math.min(size.height, this._image.height);
                      this._canvas.width = this._canvas.height * this._image.width / this._image.height;
                    } else {
                      this._canvas.width = Math.min(size.width, this._image.width);
                      this._canvas.height = this._canvas.width * this._image.height / this._image.width;
                    }
                  } else if (size.width) {
                    this._canvas.width = Math.min(size.width, this._image.width);
                    this._canvas.height = this._canvas.width * this._image.height / this._image.width;
                  } else if (size.height) {
                    this._canvas.height = Math.min(size.height, this._image.height);
                    this._canvas.width = this._canvas.height * this._image.width / this._image.height;
                  }
                }

                ctx = this._canvas.getContext('2d');
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(this._image, 0, 0, this._image.width, this._image.height, 0, 0, this._canvas.width, this._canvas.height);
                return [4, this._reload()];

              case 1:
                _a.sent();

                _a.label = 2;

              case 2:
                return [2];
            }
          });
        });
      });
      return _this;
    };
  }

  ImageUtils.loadImage = function (source, width, height) {
    return new Promise(function (resolve, reject) {
      var image = new Image(width, height);
      image.crossOrigin = 'anonymous';

      image.onload = function () {
        return resolve(image);
      };

      image.onerror = reject;
      image.src = source;
    });
  };

  return ImageUtils;
}();

var Color = function () {
  function Color() {}

  Color.getPalette = function (source, saturation) {
    if (saturation === void 0) {
      saturation = 0.7;
    }

    return __awaiter(this, void 0, void 0, function () {
      var image, colors;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, new ImageUtils().load(source).toImage()];

          case 1:
            image = _a.sent();
            colors = new ColorThief().getPalette(image);
            if (colors) return [2, colors.map(function (item) {
              var _a = Color.rgb2hsv(item),
                  h = _a[0],
                  s = _a[1],
                  v = _a[2];

              s *= saturation;
              return Color.hsv2rgb([h, s, v]);
            })];
            return [2, []];
        }
      });
    });
  };

  Color.hsv2rgb = function (color) {
    var h = color[0],
        s = color[1],
        v = color[2];
    h /= 360, s /= 100, v /= 100;
    var r = 0,
        g = 0,
        b = 0;
    var i, f, p, q, t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0:
        r = v, g = t, b = p;
        break;

      case 1:
        r = q, g = v, b = p;
        break;

      case 2:
        r = p, g = v, b = t;
        break;

      case 3:
        r = p, g = q, b = v;
        break;

      case 4:
        r = t, g = p, b = v;
        break;

      case 5:
        r = v, g = p, b = q;
        break;
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  };

  Color.rgb2hsv = function (color) {
    var r = color[0],
        g = color[1],
        b = color[2];
    var max = Math.max(r, g, b),
        min = Math.min(r, g, b),
        d = max - min;
    var h = 0,
        s = max === 0 ? 0 : d / max,
        v = max / 255;

    switch (max) {
      case min:
        h = 0;
        break;

      case r:
        h = g - b + d * (g < b ? 6 : 0);
        h /= 6 * d;
        break;

      case g:
        h = b - r + d * 2;
        h /= 6 * d;
        break;

      case b:
        h = r - g + d * 4;
        h /= 6 * d;
        break;
    }

    h *= 360, s *= 100, v *= 100;
    return [h, s, v];
  };

  return Color;
}();

export { Color as C, ImageUtils as I };
